export default __webpack_public_path__ + "static/media/PYPL.b15550b4.png";